// extracted by mini-css-extract-plugin
module.exports = {"light_ui-button-icon-color":"gray","dark_ui-button-icon-color":"#fff"};